import s from "./style.module.css";
import type { Input as ButtonInput } from "../evo-button/index.marko";
export interface Input extends ButtonInput {
    paused: boolean;
    visible?: boolean | null;
}

<const/{ paused, class: className, ...rest }=input>

<icon-button
    ...rest
    class=[s.button, className]
    size="medium"
    data-visible=(
        input.visible === null ? undefined : `${input.visible ?? true}`
    )>
    <icon-pause-20 aria-hidden="true" data-visible=`${!paused}`/>
    <icon-play-20 aria-hidden="true" data-visible=`${paused}`/>
</icon-button>
